import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'
import { dateTimeToPlainFormat } from '@/utils'
import { BibliographyClass, CollectionFlag, Prefix } from '@/types'

export interface RemindHistory {
  id: number
  bibliographyClass: BibliographyClass
  prefix: Prefix
  searchType: SystemCode
  displayTitle: string
  displayAuthor: string
  collectionId: number
  collectionNo: string
  reminderTime: string
  reminderType: SystemCode
  reminderMemo: string
  reminderName: string
  collectionFlag: CollectionFlag
}

export function RemindHistoryFromJSON(json: any): RemindHistory {
  return {
    id: exists(json, 'id') ? json.id : 0,
    collectionNo: exists(json, 'collection_no') ? json.collection_no : '',
    bibliographyClass: exists(json, 'bibliography_class')
      ? json.bibliography_class
      : BibliographyClass.Real,
    prefix: exists(json, 'prefix') ? json.prefix : Prefix.Set,
    searchType: exists(json, 'search_type')
      ? SystemCodeFromJSON(json.search_type)
      : defaultSystemCode(),
    displayTitle: exists(json, 'display_title') ? json.display_title : '',
    displayAuthor: exists(json, 'display_author') ? json.display_author : '',
    collectionId: exists(json, 'collection_id') ? json.collection_id : 0,
    reminderTime: exists(json, 'reminder_time')
      ? dateTimeToPlainFormat(json.reminder_time)
      : '',
    reminderType: exists(json, 'reminder_type')
      ? SystemCodeFromJSON(json.reminder_type)
      : defaultSystemCode(),
    reminderMemo: exists(json, 'reminder_memo') ? json.reminder_memo : '',
    reminderName: exists(json, 'reminder_name') ? json.reminder_name : '',
    collectionFlag: exists(json, 'collection_flag')
      ? json.collection_flag
      : CollectionFlag.NotCollection
  }
}
